import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import bell_icon from "../assets/images/bell_icon.png";
import {GetAllNotifications,MarkNotificationAsRead,MarkAllNotificationsAsRead,} from "../Services/NotificationService";
import {NotificationConnection,startNotificationConnection} from "../signalr/NotificationConnection";

export default function NotificationDropdown() {
  const [open, setOpen] = useState(false);
  const [list, setList] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  
  const userId = Number(localStorage.getItem("userId"));
  const CURRENT_USER_ID = userId;


  const loadTop = async (userId) => {
    const params = {
      adminId: userId,
      role: "Admin",
      type: "all",
      pageIndex: 0,
      pageSize: 5,
    };

    const res = await GetAllNotifications(params);

    const notificationData = res.data;
    const listData = notificationData.notificationList || [];

    // Set unread count from backend
    setUnreadCount(notificationData.totalUnread);

    // Set top 10 notifications
    setList(listData);
  };

  useEffect(() => {
  const init = async () => {
    if (!userId) return; // wait until userId is set
    await startNotificationConnection();  // wait until connected

    loadTop(userId); // first load

    NotificationConnection.on("ReceiveNotification", () => {
      // setUnreadCount((c) => c + 1);
      loadTop(userId);    // realtime refresh
    });

    // 🔹 Read/updated notifications
    NotificationConnection.on("NotificationUpdated", () => {
      loadTop(userId); // refresh counts + list
    });
  };

  init();

  return () => {
    NotificationConnection.off("ReceiveNotification");
    NotificationConnection.off("NotificationUpdated");
  };
}, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSingleRead = async (notificationId) => {
    var res = await MarkNotificationAsRead(notificationId, CURRENT_USER_ID);
    if (!res.status) {
      alert(res.message);
    }
  };

  const handleMarkAllRead = async () => {
    var res = await MarkAllNotificationsAsRead(CURRENT_USER_ID, "Admin");
    if (!res.status) {
      alert(res.message);
    }
  };

  return (
    <div className="position-relative" ref={dropdownRef}>
      <div style={{ position: "relative", cursor: "pointer" }} onClick={() => setOpen(!open)}>
        <img src={bell_icon} alt="Notifications" className="icon" />
        {unreadCount > 0 && (
          <span
            style={{
              position: "absolute",
              top: -5,
              right: -5,
              background: "red",
              color: "white",
              borderRadius: "50%",
              fontSize: "10px",
              padding: "2px 6px",
            }}
          >
            {unreadCount}
          </span>
        )}
      </div>

      {open && (
        <div
  className="position-absolute bg-white shadow rounded p-2"
  style={{ 
    top: "40px", 
    right: 0, 
    width: "320px", 
    zIndex: 999
  }}
>
  {/* Sticky Header */}
  <div
    className="d-flex justify-content-between align-items-center mb-2"
    style={{
      position: "sticky",
      top: 0,
      background: "white",
      zIndex: 10,
      paddingTop: "2px",
    }}
  >
    <strong>Notifications</strong>
    {list.length > 0 && (
      <span
        style={{ cursor: "pointer", color: "blue", fontSize: "12px" }}
        onClick={handleMarkAllRead}
      >
        Mark all as read
      </span>
    )}
  </div>

  {list.length === 0 && <p className="text-center m-0">No notifications</p>}

  {list.map((n) => (
    <div
      key={n.notificationId}
      className="p-2 mb-1 rounded d-flex justify-content-between align-items-center"
      style={{ background: "#f5f5f5" }}
    >
      <div className="me-2">
        <div style={{ fontSize: "13px", fontWeight: 600 }}>{n.title}</div>
        <div style={{ fontSize: "12px" }}>{n.message}</div>
      </div>
      <button
        className="btn btn-sm btn-link text-danger p-0"
        onClick={() => handleSingleRead(n.notificationId)}
      >
        Read
      </button>
    </div>
  ))}

  <div
    className="text-center mt-2"
    style={{ cursor: "pointer", color: "blue", fontSize: "13px" }}
    onClick={() => {
      setOpen(false);
      navigate("/notifications");
    }}
  >
    View all
  </div>
</div>

      )}
    </div>
  );
}